import { KeySubjects } from './keys-subjects-section';

export const arrSubjectControllGenderF = [
  KeySubjects.keyMadre,
  KeySubjects.keyMadreBio,
  KeySubjects.keySposa,
];

export const arrSubjectControllGenderM = [
  // KeySubjects.keyPadre,
  KeySubjects.keyPadreBio,
  KeySubjects.keySposo,
];
